export const isProductPreorderAllowed = (isPreorderAllowed, hasSize, sizeDependentPrice, isBox) => {
  return !isBox && (isPreorderAllowed || hasSize && !sizeDependentPrice);
};